import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Header from "./Header.vue";
import Footer from "./Footer.vue";
import CookiesConsent from "@/components/CookieConsent.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", null, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createVNode(Footer),
    _createVNode(CookiesConsent)
  ], 64))
}
}

})